import { Alert, DialogContent, DialogTitle, Stack, Typography } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { If } from "lib/@components/switch"
import { ModifierType } from "./modifier-type"
import { ModifierValue } from "./modifier-value"
import { ModifierApplyTo } from "./modifier-apply-to"
import {
    createRateCardModifierFormValue,
    isRateCardModifierFormInvalid,
    normalizeRateCardModifier,
} from "./rate-card-modifier-form"
import { formatRateCardModifierScope, isLegacyScopedModifier } from "./rate-card-modifier-scope"

export function RateCardModifierDialog({ modifier, tradeOptions }) {
    const isEditing = !!modifier
    const initialValue = createRateCardModifierFormValue(modifier)
    const legacyScope = isLegacyScopedModifier(modifier)
    const legacyScopeLabel = formatRateCardModifierScope(modifier?.scope, tradeOptions)
    const title = isEditing ? "Edit Modifier" : "Add Modifier"
    const okCaption = isEditing ? "Save" : "Add modifier"

    return (
        <DataInputDialog
            initialValue={initialValue}
            okCaption={okCaption}
            beforeOk={normalizeRateCardModifier}
            okDisabled={isRateCardModifierFormInvalid}
            startValid={isEditing}
        >
            <DialogTitle sx={{ pb: 3 }}>{title}</DialogTitle>
            <DialogContent>
                <Stack spacing={2.5} sx={{ mt: 1 }}>
                    <If value={legacyScope}>
                        <Alert severity="warning" data-cy="modifier-legacy-scope-warning">
                            This modifier uses the legacy scope <strong>{legacyScopeLabel}</strong>. Saving changes will
                            preserve that scope. To replace it, create a rule in a rule set, then delete this modifier.
                        </Alert>
                    </If>
                    <BoundTextField
                        field="name"
                        label="Name"
                        placeholder="e.g. Management fee"
                        yup="string.required.max(60)"
                        autoFocus
                        fullWidth
                    />
                    <ModifierType />
                    <ModifierValue />
                    <ModifierApplyTo />
                    <Typography variant="body2" color="text.secondary" data-cy="modifier-scope-guidance">
                        Modifiers apply to the whole regime. For more specific cost adjustments (e.g. by trade, facility
                        or location), use a rule in a rule set.
                    </Typography>
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
